
import { Component, Vue, Prop } from "vue-property-decorator";

import ComposeQuestTable from "../ComposeQuestTable.vue";
import { Quests } from "@/models/MapPois/Quest/Quests";
import EditQuest from "../EditQuest.vue";
import SavePanel from "@/components/Base/SavePanel.vue";
import { Game } from "@/models/Game";
import { City } from "@/models/City";
import { Q_QUEST_TYPE } from "@/models/MapPois/Quest/QuestsEnum";

@Component({
  components: {
    SavePanel,
    ComposeQuestTable,
    EditQuest,
  },
})
class ComposeQuest extends Vue {
  @Prop({ default: null }) readonly gameData!: Game;
  @Prop({ default: false }) readonly isEditingLocked!: boolean;
  showSavePanel = false;
  showEditQuestPanel = false;
  questKey = "";

  get getCityData(): City {
    return this.$store.state.cityStore.singleCity;
  }

  get getQuestData(): Quests[] {
    return this.$store.state.questStore.quest;
  }

  get getMainQuestsCount(): number {
    return this.getQuestData.filter((quest) => quest.type === Q_QUEST_TYPE.MAIN)
      .length;
  }
  get getPrimaryQuestsCount(): number {
    return this.getQuestData.filter(
      (quest) => quest.type === Q_QUEST_TYPE.PRIMARY
    ).length;
  }
  get getSecondaryQuestsCount(): number {
    return this.getQuestData.filter(
      (quest) => quest.type === Q_QUEST_TYPE.SECONDARY
    ).length;
  }
  get getMiscQuestsCount(): number {
    return this.getQuestData.filter((quest) => quest.type === Q_QUEST_TYPE.MISC)
      .length;
  }
  created(): void {
    this.$store.dispatch("mapPoiStore/getPoiType", this.gameData.gt_uid);
  }

  openLocation(key: string): void {
    this.openPoi(key);
  }

  handleTableSelection(rows: Quests): void {
    this.openPoi(rows.key);
  }

  openPoi(key: string): void {
    this.$store.dispatch("mapPoiStore/getFxData", this.gameData);
    this.$store.dispatch("mapPoiStore/getInventoryData", this.gameData);
    this.questKey = key;
    this.showEditQuestPanel = true;
  }
  closeEditPoi(): void {
    this.showEditQuestPanel = false;
  }
}

export default ComposeQuest;
